import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from 'src/utils/axios'

type BuilderSettingsType = {
  builder_id: number | null
  country: string
  logo: string
  primary_color: string
  secondary_color: string
  selfie_verification_active: boolean
}

type BuilderType = {
  builder_id: number | null
  settings: BuilderSettingsType
  loading: boolean
}

const initialState: BuilderType = {
  builder_id: null,
  settings: {
    builder_id: null,
    country: '',
    logo: '',
    primary_color: '',
    secondary_color: '',
    selfie_verification_active: false,
  },
  loading: true,
}

const builderSlice = createSlice({
  name: 'builder',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder.addCase(getBuilderId.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBuilderId.fulfilled, (state, action) => {
      state.loading = false
      state.builder_id = action.payload
    })
    builder.addCase(getBuilderId.rejected, (state, action) => {
      state.loading = false
      state.builder_id = null
      console.log(action.payload)
    })

    // Fetch Builder Details
    builder.addCase(fetchBuilderDetails.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchBuilderDetails.fulfilled, (state, action) => {
      state.loading = false
      state.settings = action.payload
    })
    builder.addCase(fetchBuilderDetails.rejected, (state, action) => {
      state.loading = false
      state.settings = initialState.settings
      console.log(action.payload)
    })
  },
})

export const getBuilderId = createAsyncThunk(
  'builder/getId',
  async (name: string) => {
    const resp = await http.get(`builders/name/${name}`)
    return resp.data.builderId
  }
)

export const fetchBuilderDetails = createAsyncThunk(
  'builder/fetchDetails',
  async (id: number) => {
    const resp = await http.get(`builders/settings/${id}`)
    return resp.data
  }
)

export default builderSlice.reducer;